export function handleRoundNumber(number, significantNumber) {
    return (
        Math.round(number * Math.pow(10, significantNumber)) /
        Math.pow(10, significantNumber)
    )
}

